// import htttp from "../../../helpers/axios";
import { BlogData } from '../../../api'
// state is where all the data are at, all the values.
const state = {
  BlogData: [],
}
// getters is there to get value from state or get filtered value from state
const getters = {
  BlogData: (state) => state.BlogData,
  getBlogById(state) {
    return (id) => {
      return state.BlogData.find((el) => {
        // console.log("the el.id is: " + el.id);
        return el.id == id
      })
    }
  },
}
//  mutations is there to update the state. here Homedata in state is assigned the value of payload
const mutations = {
  saveBlogData(state, payload) {
    state.BlogData = payload
  },
  saveBlogDataByID(state, { data, id }) {
    if (!state.BlogData.includes((el) => el.id == id)) {
      state.BlogData.push(data)
    }
  },
}
// actions is there to call mutations. and the data( data.data ) given to in action in commit goes as payload to mutations
const actions = {
  GET_BLOGDATA: ({ commit }) => {
    // let { data } = await htttp.get(BlogData);
    fetch(BlogData)
      .then(function(response) {
        return response.json()
      })
      .then(function(data) {
        // console.log(data)
        commit('saveBlogData', data)
      })
  },
  GET_BLOGDATA_BY_ID: ({ commit }, id = 0) => {
    // let { data } = await htttp.get(`${BlogData}/${id}`);
    // console.log(id);
    // console.log(`${BlogData}/${id}`)
    fetch(`${BlogData}/${id}`)
      .then(function(response) {
        return response.json()
      })
      .then(function(data) {
        // console.log(data)
        commit('saveBlogDataByID', {
          data: data,
          id,
        })
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
